import React from "react";
import { Youtube, Instagram, Facebook, Linkedin } from "lucide-react";
import { SOCIALS } from "../data/site";

const XIcon = ({ size = 18, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const ICONS = { youtube: Youtube, instagram: Instagram, facebook: Facebook, x: XIcon, linkedin: Linkedin };

export const SocialLinks = ({ prefix = "social", size = "md", showLabels = false }) => {
  const dim = size === "sm" ? "w-9 h-9" : "w-10 h-10";
  return (
    <ul className={showLabels ? "grid grid-cols-1 sm:grid-cols-2 gap-3" : "flex flex-wrap items-center gap-3"}>
      {SOCIALS.map((s) => {
        const Icon = ICONS[s.id];
        return (
          <li key={s.id}>
            <a
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Visit ${s.label} on ${s.name} (opens in a new tab)`}
              title={s.name}
              data-testid={`${prefix}-social-${s.id}`}
              className={showLabels ? "group flex items-center gap-3 text-sm text-slate-300 hover:text-white transition-colors" : "group block"}
            >
              <span
                className={`${dim} rounded-full grid place-items-center bg-white/5 border border-white/10 text-slate-300 group-hover:text-white group-hover:bg-brand-orange group-hover:border-brand-orange transition-colors duration-200 shrink-0`}
              >
                <Icon size={18} />
              </span>
              {showLabels && (
                <span className="min-w-0 leading-tight">
                  <span className="block font-mono text-[10px] tracking-wider uppercase text-slate-500">{s.name}</span>
                  <span className="block truncate">{s.label}</span>
                </span>
              )}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default SocialLinks;
